/**
 * @fileoverview GET handler for the "/engagement/locations_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementLocationsTags } from "./constants";
import type { EngagementLocationsTagsResult } from "./types";

export const getEngagementLocationsTags = reactQueryFetcherAdapter(
  engagementLocationsTags,
  (signal: AbortSignal): Promise<EngagementLocationsTagsResult> => {
    return fetch("/engagement/locations_tags", "GET", {}, { signal });
  }
);
